import type { PropsWithChildren } from 'react'
import { Navigate, useSearchParams } from 'router-v6'
import { useAuth } from 'v2/shared/hooks/use-auth'
import { logger } from 'v2/utils/logger'
import { getSafeRedirectUrl } from 'v2/utils/url-validation'

export const ProtectedRoute: React.FC<PropsWithChildren> = ({ children }) => {
  const auth = useAuth()
  const [searchParams] = useSearchParams()
  const nextUrl = getSafeRedirectUrl(searchParams.get('next_url'))
  const returnTo = getSafeRedirectUrl(searchParams.get('return_to'))

  if (!auth.userAuthenticated) {
    logger.log('Protected route - User not authenticated')
    // Preserve both pathname AND query string so params like ?brand_id=123 survive the login redirect.
    // encodeURIComponent prevents the inner ? and & from being parsed as outer query params.
    const currentPath = window.location.pathname + window.location.search
    const paramsArr = []
    paramsArr.push(`next_url=${encodeURIComponent(nextUrl || currentPath)}`)
    if (returnTo) paramsArr.push(`return_to=${encodeURIComponent(returnTo)}`)
    const params = paramsArr.length ? `?${paramsArr.join('&')}` : ''
    return <Navigate to={`/login${params}`} />
  }

  if (nextUrl || returnTo) {
    return <Navigate to={nextUrl || returnTo || '/'} />
  }

  return <>{children}</>
}
